var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoardActivity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.24606 14.0013C10.2126 14.0013 10.9961 14.7848 10.9961 15.7513V19.2513C10.9961 20.2178 10.2126 21.0013 9.24606 21.0013H3.75C2.7835 21.0013 2 20.2178 2 19.2513V15.7513C2 14.7848 2.7835 14.0013 3.75 14.0013H9.24606ZM20.25 14.0013C21.2165 14.0013 22 14.7848 22 15.7513V19.2513C22 20.2178 21.2165 21.0013 20.25 21.0013H14.7539C13.7874 21.0013 13.0039 20.2178 13.0039 19.2513V15.7513C13.0039 14.7848 13.7874 14.0013 14.7539 14.0013H20.25ZM20.25 2.99609C21.2165 2.99609 22 3.7796 22 4.74609V10.2495C22 11.216 21.2165 11.9995 20.25 11.9995H3.75C2.7835 11.9995 2 11.216 2 10.2495V4.74609C2 3.82792 2.70711 3.0749 3.60647 3.00189L3.75 2.99609H20.25Z",
    fill: "#5566AA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardActivity);
export default __webpack_public_path__ + "static/media/board-activity.de7b46f9.svg";
export { ForwardRef as ReactComponent };